<template>
  <div>
    <slot :progress="progress"></slot>
  </div>
</template>

<script>
class Progress {
  constructor(file, event) {
    this.file = file;
    this.event = event;
  }

  fileName() {
    return this.file.name;
  }

  percent() {
    return Math.round((this.event.loaded * 100) / this.event.total, 2);
  }

  isComplete() {
    return this.event.loaded === this.event.total;
  }
}

export default {
  props: {
    endpoint: {
      type: String,
      required: true
    },

    fileFieldName: {
      type: String,
      default: "file"
    },

    fileName: {
      type: String
    },

    additional: {
      type: Object
    },

    autoReset: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      uploadingFile: this.file,
      progress: null
    };
  },

  methods: {
    upload(file, additional = {}) {
      let formData = this.uploadFormData(file);

      for (let field in additional) {
        formData.append(field, additional[field]);
      }

      formData.append(
        this.fileFieldName,
        file,
        this.fileName ? this.fileName : undefined
      );

      this.$http
        .post(this.endpoint, formData, {
          onUploadProgress: event => {
            this.progress = new Progress(file, event);
          }
        })
        .then(this.uploaded)
        .catch(error => {
          this.$emit("failed", error);
          this.progress = null;
          new window.FailedResponseHandler(error).handle();
        });
    },

    uploadFormData() {
      let formData = new window.FormData();

      if (this.additional) {
        for (let field in this.additional) {
          formData.append(field, this.additional[field]);
        }
      }

      return formData;
    },

    uploaded(response) {
      this.$emit("uploaded", response.data);

      if (this.autoReset) {
        this.progress = null;
      }
    }
  }
};
</script>
